import { PageType, TargetParams } from "../../utils/BannerContainer";

import { Link } from "react-router";

import * as React from "react";
import { Banner, EmptyBanner } from "../../stores/BannerStore";
import { trackBannerClick } from "../../utils/BannerTrackingUtil";
import { isEmptyBanner } from "../../utils/BannerUtil";

type PropType = {
    banner: Banner | EmptyBanner;
    targetParams?: TargetParams;
    pageType: PageType;
    children?: React.ReactNode;
};

class ClickHandler extends React.Component<PropType> {
    trackClick(banner: Banner) {
        trackBannerClick(banner, this.props.pageType, this.props.targetParams);
    }

    render() {
        const banner = this.props.banner;
        const link = !isEmptyBanner(banner) && (this.props.banner as Banner).link;

        if (!link) {
            return <div className="mfcss ">{this.props.children}</div>;
        }

        if (!link.startsWith("/")) {
            return (
                <div className="mfcss" onClick={() => this.trackClick(banner as Banner)}>
                    <a href={link}>{this.props.children}</a>
                </div>
            );
        }

        return (
            <div className="mfcss" onClick={() => this.trackClick(banner as Banner)}>
                <Link to={link}>{this.props.children}</Link>
            </div>
        );
    }
}

export default ClickHandler;
